module.exports = __webpack_public_path__ + "1792771649312/fonts/Comfortaa-Bold.801965b.ttf";